export function accessibilityWidget() {
  const wrapper = document.querySelector(".page-wrapper");
  const widget = document.querySelector("#accessibility-widget");
  const widgetToggle = document.querySelector("#accessibility-widget__toggle");
  const widgetClose = document.querySelectorAll(".accessibility-widget__close");
  const resetOptions = document.querySelector("#accessibility-widget__reset");
  const resetBanner = document.getElementById("accessibility-widget__banner");
  const readingLine = document.querySelector(".reading-line");
  const readingMask = document.querySelector(".reading-mask");
  const widgetOptions = document.querySelectorAll(".accessibility-widget__option");
  const tick = document.querySelector("#accessibility-widget__toggle__tick");
  const colorBlindCheckbox = document.getElementById("color-blind");
  const dyslexiaCheckbox = document.getElementById("dyslexia");

  const textAlignOptions = [
    "text-align-left",
    "text-align-center",
    "text-align-right",
    "text-align-justify",
  ];
  let currentIndex = 0;

  // ======================================================
  // Utilities
  // ======================================================
  function getSavedOptions() {
    return JSON.parse(sessionStorage.getItem("accessibilityOptions")) || {};
  }

  function clearProfileIfActive() {
    const activeProfile = sessionStorage.getItem("accessibilityProfile");
    if (activeProfile === "colorBlind" || activeProfile === "dyslexia") {
      resetProfile();
    }
  }

  function resetZoom() {
    const slider = document.getElementById("zoom-slider");
    const zoomLevelText = document.getElementById("zoom-level");
    const zoomTick = document.querySelector("#option-zoom-screen .tick");
    const zoomOption = document.querySelector("#option-zoom-screen");
    slider.value = 100;
    wrapper.style.zoom = "1";
    updateSliderVisual(slider, 100);
    zoomLevelText.textContent = "Zoom screen: 100%";
    zoomTick.classList.remove("scale-100");
    zoomOption.classList.remove("accessibility-widget__option--active");
  }

  // ======================================================
  // 1) Restore state from sessionStorage
  // ======================================================
  document.addEventListener("DOMContentLoaded", () => {
    const activeProfile = sessionStorage.getItem("accessibilityProfile") || "";

    if (activeProfile === "colorBlind") {
      colorBlindCheckbox.checked = true;
      applyProfile("colorBlind");
    } else if (activeProfile === "dyslexia") {
      dyslexiaCheckbox.checked = true;
      applyProfile("dyslexia");
    } else {
      initAccessibilityOptions();
    }

    // Sync currentIndex with any restored text-align value
    const savedAlign = getSavedOptions().textAlign;
    currentIndex = savedAlign ? textAlignOptions.indexOf(savedAlign) + 1 : 0;

    setupZoomSlider();
    updateTickVisibility();
    addCount();
  });

  // ======================================================
  // 2) Widget open/close
  // ======================================================
  document.addEventListener("click", (event) => {
    if (
      !widget.contains(event.target) &&
      !event.target.matches(".widget-toggle") &&
      widget.classList.contains("widget-open")
    ) {
      widget.classList.remove("widget-open");
    }
  });

  widgetToggle.addEventListener("click", () => {
    widget.classList.add("widget-open");
  });

  widgetClose.forEach((elem) => {
    elem.addEventListener("click", () => {
      widget.classList.remove("widget-open");
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && widget.classList.contains("widget-open")) {
      widget.classList.remove("widget-open");
    }
  });

  // ======================================================
  // 3) Profile checkbox changes
  // ======================================================
  colorBlindCheckbox.addEventListener("change", (e) => {
    if (e.target.checked) {
      applyProfile("colorBlind");
      dyslexiaCheckbox.checked = false;
    } else {
      resetProfile();
    }
  });

  dyslexiaCheckbox.addEventListener("change", (e) => {
    if (e.target.checked) {
      applyProfile("dyslexia");
      colorBlindCheckbox.checked = false;
    } else {
      resetProfile();
    }
  });

  // ======================================================
  // 4) Individual option toggles
  // ======================================================
  widgetOptions.forEach((option) => {
    option.addEventListener("click", () => {
      if (option.id === "option-zoom-screen") return;

      clearProfileIfActive();
      option.classList.toggle("accessibility-widget__option--active");

      switch (option.id) {
        case "option-grayscale":         wrapper.classList.toggle("grayscale"); break;
        case "option-font-size":         wrapper.classList.toggle("large-font"); break;
        case "option-line-height":       wrapper.classList.toggle("line-height"); break;
        case "option-dyslexia-friendly": wrapper.classList.toggle("dyslexia-friendly"); break;
        case "option-hide-images":       wrapper.classList.toggle("hide-images"); break;
        case "option-bigger-cursor":     wrapper.classList.toggle("bigger-cursor"); break;
        case "option-reading-line":      readingLine.classList.toggle("enabled"); break;
        case "option-reading-mask":      readingMask.classList.toggle("enabled"); break;
        case "option-highlight-links":   wrapper.classList.toggle("highlight-links"); break;
        case "option-high-saturation":   wrapper.classList.toggle("high-saturation"); break;
        case "option-low-saturation":    wrapper.classList.toggle("low-saturation"); break;
        case "option-high-contrast":     wrapper.classList.toggle("high-contrast"); break;
      }

      saveOptions();
      updateTickVisibility();
      addCount();
    });
  });

  // ======================================================
  // 5) Text align cycling
  // ======================================================
  const textAlignLabel = document.querySelector("#option-text-align span");

  document.getElementById("option-text-align").addEventListener("click", function () {
    clearProfileIfActive();
    wrapper.classList.remove(...textAlignOptions);

    if (currentIndex === textAlignOptions.length) {
      textAlignLabel.textContent = "Text Alignment";
      currentIndex = 0;
      this.classList.remove("accessibility-widget__option--active");
    } else {
      const newClass = textAlignOptions[currentIndex];
      textAlignLabel.textContent = formatAlignName(newClass);
      wrapper.classList.add(newClass);
      currentIndex++;
      this.classList.add("accessibility-widget__option--active");
    }

    saveOptions();
  });

  function formatAlignName(cssClass) {
    const base = cssClass.replace("text-align-", "");
    return base.charAt(0).toUpperCase() + base.slice(1);
  }

  // ======================================================
  // 6) Reading line & mask — throttled via rAF
  // ======================================================
  let rafPending = false;
  document.addEventListener("mousemove", (e) => {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(() => {
      updateReadingTools(e.clientY);
      rafPending = false;
    });
  });

  function updateReadingTools(y) {
    readingLine.style.top = `${y}px`;
    const cutoutHeight = 150;
    const top = y - cutoutHeight / 2;
    const bottom = y + cutoutHeight / 2;
    readingMask.style.clipPath = `polygon(
      0 0, 100% 0,
      100% ${top}px, 0 ${top}px,
      0 ${bottom}px, 100% ${bottom}px,
      100% 100%, 0 100%
    )`;
  }

  // ======================================================
  // 7) Zoom slider
  // ======================================================
  function setupZoomSlider() {
    const slider = document.getElementById("zoom-slider");
    const zoomLevelText = document.getElementById("zoom-level");
    const zoomTick = document.querySelector("#option-zoom-screen .tick");
    const zoomOption = document.querySelector("#option-zoom-screen");

    const savedZoom = parseInt(getSavedOptions().zoomLevel || 100, 10);
    applyZoom(savedZoom);
    slider.value = savedZoom;
    updateSliderVisual(slider, savedZoom);
    zoomLevelText.textContent = `Zoom screen: ${savedZoom}%`;

    if (savedZoom !== 100) {
      zoomTick.classList.add("scale-100");
      zoomOption.classList.add("accessibility-widget__option--active");
    } else {
      zoomTick.classList.remove("scale-100");
      zoomOption.classList.remove("accessibility-widget__option--active");
    }

    slider.addEventListener("input", () => {
      const zoomValue = parseInt(slider.value, 10) || 100;
      clearProfileIfActive();
      applyZoom(zoomValue);
      updateSliderVisual(slider, zoomValue);
      zoomLevelText.textContent = `Zoom screen: ${zoomValue}%`;

      const newOptions = getSavedOptions();
      newOptions.zoomLevel = zoomValue;
      sessionStorage.setItem("accessibilityOptions", JSON.stringify(newOptions));

      if (zoomValue !== 100) {
        zoomTick.classList.add("scale-100");
        zoomOption.classList.add("accessibility-widget__option--active");
      } else {
        zoomTick.classList.remove("scale-100");
        zoomOption.classList.remove("accessibility-widget__option--active");
      }

      saveOptions();
      updateTickVisibility();
      addCount();
    });
  }

  function applyZoom(zoomValue) {
    wrapper.style.zoom = zoomValue / 100;
  }

  function updateSliderVisual(slider, zoomValue) {
    const percent = ((zoomValue - 10) / 190) * 100;
    slider.style.setProperty("--value", `${percent}%`);
  }

  // ======================================================
  // 8) Reset all toggles (used by profiles and reset button)
  // ======================================================
  function resetAllToggles() {
    widgetOptions.forEach((option) => {
      option.classList.remove("accessibility-widget__option--active");
    });

    wrapper.classList.remove(
      "grayscale", "large-font", "line-height", "dyslexia-friendly",
      "hide-images", "bigger-cursor", "highlight-links", "high-saturation",
      "low-saturation", "high-contrast", "text-align-left", "text-align-center",
      "text-align-right", "text-align-justify"
    );

    readingLine.classList.remove("enabled");
    readingMask.classList.remove("enabled");

    const textAlignSpan = document.querySelector("#option-text-align span");
    if (textAlignSpan) textAlignSpan.textContent = "Text Alignment";
    currentIndex = 0;

    sessionStorage.setItem("accessibilityOptions", JSON.stringify({}));
  }

  // ======================================================
  // 9) Profile logic
  // ======================================================
  function applyProfile(profileName) {
    resetAllToggles();
    resetZoom();

    sessionStorage.setItem("accessibilityProfile", profileName);

    if (profileName === "colorBlind") {
      wrapper.classList.add("high-contrast");
      const hcOption = document.getElementById("option-high-contrast");
      if (hcOption) hcOption.classList.add("accessibility-widget__option--active");
    } else if (profileName === "dyslexia") {
      wrapper.classList.add("dyslexia-friendly");
      const dysOption = document.getElementById("option-dyslexia-friendly");
      if (dysOption) dysOption.classList.add("accessibility-widget__option--active");
    }

    saveOptions();
    updateTickVisibility();
    addCount();
  }

  function resetProfile() {
    wrapper.classList.remove("high-contrast", "dyslexia-friendly");
    colorBlindCheckbox.checked = false;
    dyslexiaCheckbox.checked = false;
    sessionStorage.setItem("accessibilityProfile", "");
    saveOptions();
    updateTickVisibility();
    addCount();
  }

  // ======================================================
  // 10) Restore toggles from storage (no active profile)
  // ======================================================
  function initAccessibilityOptions() {
    const options = getSavedOptions();

    if (options.grayscale)        wrapper.classList.add("grayscale");
    if (options.largeFont)        wrapper.classList.add("large-font");
    if (options.lineHeight)       wrapper.classList.add("line-height");
    if (options.dyslexiaFriendly) wrapper.classList.add("dyslexia-friendly");
    if (options.hideImages)       wrapper.classList.add("hide-images");
    if (options.biggerCursor)     wrapper.classList.add("bigger-cursor");
    if (options.highlightLinks)   wrapper.classList.add("highlight-links");
    if (options.highSaturation)   wrapper.classList.add("high-saturation");
    if (options.lowSaturation)    wrapper.classList.add("low-saturation");
    if (options.highContrast)     wrapper.classList.add("high-contrast");

    if (options.textAlign) {
      wrapper.classList.add(options.textAlign);
      const span = document.querySelector("#option-text-align span");
      if (span) span.textContent = formatAlignName(options.textAlign);
    }
    if (options.addReadingLine) readingLine.classList.add("enabled");
    if (options.addReadingMask) readingMask.classList.add("enabled");

    widgetOptions.forEach((option) => {
      if (options[option.id]) {
        option.classList.add("accessibility-widget__option--active");
      }
    });
  }

  // ======================================================
  // 11) Save / read state
  // ======================================================
  function saveOptions() {
    const options = getSavedOptions();

    options.grayscale        = wrapper.classList.contains("grayscale");
    options.largeFont        = wrapper.classList.contains("large-font");
    options.lineHeight       = wrapper.classList.contains("line-height");
    options.dyslexiaFriendly = wrapper.classList.contains("dyslexia-friendly");
    options.hideImages       = wrapper.classList.contains("hide-images");
    options.biggerCursor     = wrapper.classList.contains("bigger-cursor");
    options.highlightLinks   = wrapper.classList.contains("highlight-links");
    options.highSaturation   = wrapper.classList.contains("high-saturation");
    options.lowSaturation    = wrapper.classList.contains("low-saturation");
    options.highContrast     = wrapper.classList.contains("high-contrast");
    options.addReadingLine   = readingLine.classList.contains("enabled");
    options.addReadingMask   = readingMask.classList.contains("enabled");

    if (wrapper.classList.contains("text-align-left"))         options.textAlign = "text-align-left";
    else if (wrapper.classList.contains("text-align-center"))  options.textAlign = "text-align-center";
    else if (wrapper.classList.contains("text-align-right"))   options.textAlign = "text-align-right";
    else if (wrapper.classList.contains("text-align-justify")) options.textAlign = "text-align-justify";
    else                                                        options.textAlign = "";

    const sliderEl = document.getElementById("zoom-slider");
    if (sliderEl) options.zoomLevel = parseInt(sliderEl.value, 10);

    widgetOptions.forEach((option) => {
      options[option.id] = option.classList.contains("accessibility-widget__option--active");
    });

    sessionStorage.setItem("accessibilityOptions", JSON.stringify(options));
    updateTickVisibility();
  }

  // ======================================================
  // 12) UI helpers
  // ======================================================
  function updateTickVisibility() {
    const anyOptionActive = [...widgetOptions].some((option) =>
      option.classList.contains("accessibility-widget__option--active")
    );
    if (anyOptionActive) {
      tick.classList.add("show");
      resetOptions.classList.remove("disabled");
      resetOptions.removeAttribute("disabled");
    } else {
      tick.classList.remove("show");
      resetOptions.classList.add("disabled");
      resetOptions.setAttribute("disabled", "");
    }
  }

  function addCount() {
    const parents = document.querySelectorAll("#accessibility-widget .accordion__item");
    parents.forEach((parent) => {
      const heading = parent.querySelector(".toggle-heading");
      if (!heading) return;

      const count = parent.querySelectorAll(".accessibility-widget__option--active").length;
      let countSpan = heading.querySelector(".rounded-full");
      if (!countSpan) {
        countSpan = document.createElement("span");
        countSpan.className = "inline-flex text-[11px] w-[20px] items-center justify-center font-bold rounded-full shrink-0 aspect-square bg-primary";
        heading.appendChild(countSpan);
      }

      countSpan.textContent = count;
      countSpan.style.display = count > 0 ? "" : "none";
    });
  }

  // ======================================================
  // 13) Reset button
  // ======================================================
  resetOptions.addEventListener("click", () => {
    const activeProfile = sessionStorage.getItem("accessibilityProfile");
    if (activeProfile === "colorBlind" || activeProfile === "dyslexia") {
      resetProfile();
    }

    const anyOptionActive = [...widgetOptions].some((option) =>
      option.classList.contains("accessibility-widget__option--active")
    );

    resetAllToggles();
    resetZoom();

    colorBlindCheckbox.checked = false;
    dyslexiaCheckbox.checked = false;
    sessionStorage.removeItem("accessibilityOptions");

    if (anyOptionActive) {
      resetBanner.classList.add("show");
      setTimeout(() => resetBanner.classList.remove("show"), 3000);
    }

    updateTickVisibility();
    addCount();
  });
}
